import parameters from '../../../../components/Main/Newsletter/EmailRenderer/parameters'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import React from 'react'
import _, { template, get, isEmpty } from 'lodash'
import ReactHtmlParser from 'react-html-parser'
import { Spin } from 'antd'

function EmailRenderer(props) {
  const newsletter = get(props, 'match.params.newsletter', '')

  console.log(55, newsletter)

  const { data, fetching: loading, fetchURL } = useFetchURL(`foxxapi/newsletter/${newsletter}`)

  console.log(data)

  // const data = get(response, 'html')
  _.templateSettings = {
    interpolate: /\{\{=(.+?)\}\}/g,
    evaluate: /\{\{(.+?)\}\}/g,
  }
  const compiled = template(get(data, 'masterHTML.body', '<span>Loading ...</span>'))
  const html = compiled({ ...parameters, ...data.parameters, body: get(data, 'html.html', '<span>Loading ...</span>') })
  //   ...get(data, 'receiver.attributes', {}),
  //   unsubscribeLink: `/unsubscribe/${templateID}/${email}`,
  //   newsletterLink: `/newsletter/${templateID}/${email}`,

  console.log(data)
  return loading ? (
    <Spin
      size="large"
      spinning={loading}
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: ' center',
        alignItems: 'center',
        textAlign: 'center',
        minHeight: '100vh',
      }}
    />
  ) : (
    ReactHtmlParser(html)
  )
}

export default EmailRenderer
